import React, { useEffect, useState } from 'react';
import { ScheduleComponent, Day, Week, WorkWeek, Month, Inject } from '@syncfusion/ej2-react-schedule';
import { registerLicense } from '@syncfusion/ej2-base';

// Paste your license key inside the string below
registerLicense('ORg4AjUWIQA/Gnt2XFhhQlJHfVhdWHxLflFzVWBTfV56dFdWACFaRnZdR11lSXtSc0dkWH5bcn1cTWJV');

// Optional: Custom styling for events
const onEventRendered = (args) => {
    const eventColor = args.data.CategoryColor || '#FF52C5';
    args.element.style.backgroundColor = eventColor;
    args.element.style.borderRadius = '8px';
    args.element.style.color = 'white';
  };

const SchedulerView = ({instituteClasses}) => {
  console.log("instituteClasses in the show schedule is:",instituteClasses)

  const eventTemplate = (props) => {
    return (
      <div style={{ padding: '4px' }}>
        <div><strong>{props.Subject}</strong></div>
            {/* {props.InstructorName && <div>Instructor: {props.InstructorName}</div>} */}
            {props.StudentName && <div>{props.StudentName}</div>}
            {props.StartTime && (
                <div>
                    {props.StartTime.toLocaleTimeString()} - {props.EndTime.toLocaleTimeString()}
                </div>
            )}
      </div>
    );
  };

  return (
    <ScheduleComponent
      timeFormat="hh:mm a"
      height="1500px"
      //   eventSettings={{ dataSource: instituteClasses }}
      eventSettings={{
          dataSource: instituteClasses,
          template: eventTemplate,
      }}
      eventRendered={onEventRendered}
      currentView="Week"
    >
      <Inject services={[Day, Week, WorkWeek, Month]} />
    </ScheduleComponent>
  );
};

export default SchedulerView;

